import { render, staticRenderFns } from "./IconMicrophoneOutline.vue?vue&type=template&id=552eeeaa"
import script from "./IconMicrophoneOutline.vue?vue&type=script&lang=js"
export * from "./IconMicrophoneOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports